import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { OrgWithOwnerDto } from "../../../autogen/bff-api";

interface Props {
  duplicateOrgs: OrgWithOwnerDto[] | null;
  onCancel: () => void;
  onContinue: () => void;
}

export const DuplicateOrgsModal = ({ duplicateOrgs, onCancel, onContinue }: Props) => {
  const { t } = useTranslation();
  const isOpen = duplicateOrgs !== null && duplicateOrgs.length > 0;
  const isSingle = duplicateOrgs?.length === 1;

  return (
    <Modal isOpen={isOpen} onClose={onCancel} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {isSingle ? t("Organization already registered") : t("Organizations already registered")}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            {isSingle
              ? t("An organization is already registered with this organization number. The owner is:")
              : t("Several organizations are already registered with this organization number. The owners are:")}
          </Text>
          <Stack spacing={2} mt={4}>
            {duplicateOrgs?.map((org) => (
              <Box key={org.organizationId} p={3} borderWidth="1px" borderRadius="md" borderColor="smBorder">
                <Text fontWeight="semibold">{org.ownerName}</Text>
                <Text fontSize="sm">{org.ownerEmail}</Text>
              </Box>
            ))}
          </Stack>
          <Text mt={5}>
            {isSingle
              ? t("You can ask the owner for access, or create a separate organization.")
              : t("You can ask one of the owners for access, or create a separate organization.")}
          </Text>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="outline" onClick={onCancel}>
            {t("Cancel")}
          </Button>
          <Button colorScheme="teal" onClick={onContinue}>
            {t("Continue with separate organization")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
